import { useState, useCallback } from "react";

export const useInsuranceModals = () => {
  const [editModal, setEditModal] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedInsuranceDeletionId, setSelectedInsuranceDeletionId] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [activeTab, setActiveTab] = useState("company");

  const openEditModal = useCallback((tab, data = {}) => {
    setActiveTab(tab);
    setEditModal(data);
    setModalShow(true);
  }, []);

  const closeEditModal = useCallback(() => {
    setModalShow(false);
    setEditModal({});
  }, []);

  const openDeleteModal = useCallback((insuranceId) => {
    setSelectedInsuranceDeletionId(insuranceId);
    setShowDeleteModal(true);
    setModalShow(false);
  }, []);

  const closeDeleteModal = useCallback(() => {
    setShowDeleteModal(false);
    setSelectedInsuranceDeletionId(null);
  }, []);

  return {
    editModal,
    showDeleteModal,
    selectedInsuranceDeletionId,
    modalShow,
    activeTab,
    openEditModal,
    closeEditModal,
    openDeleteModal,
    closeDeleteModal,
  };
};
